import { Popconfirm } from 'antd';
import Table, { ColumnsType } from 'antd/es/table';
import { SorterResult } from 'antd/es/table/interface';
import React, { FC } from 'react';
import { FaPen, FaTrash } from 'react-icons/fa';
import { Link } from 'react-router-dom';

import { CustomButton, InputCheckbox, InputText } from '../../../../components';
import {
  StyledFiltersContainer,
  StyledTableContainer,
} from '../../../../utils/styles';
import { PaginationData } from '../../../../utils/types';
import { Semitrailer } from '../../../../utils/types/semitrailer';
import { TableData } from '../../types';
import { transformData } from './utils';

type Props = {
  data?: Semitrailer[] | null;
  onInputFilterChange: (value: string) => void;
  onInputCheckboxChange: (value: boolean) => void;
  onDeleteSemitrailer: (semitrailerID: string) => void;
  paginationData: PaginationData;
  onTableChange: (
    _pagination: any,
    _filters: any,
    sorter: SorterResult<TableData> | SorterResult<TableData>[],
  ) => void;
};

const SemitrailersTable: FC<Props> = ({
  data,
  onInputFilterChange,
  onInputCheckboxChange,
  onDeleteSemitrailer,
  paginationData,
  onTableChange,
}) => {
  const newData = transformData(data);

  const columns: ColumnsType<TableData> = [
    {
      title: 'Número de Patente',
      dataIndex: 'license_plate',
      key: 'license_plate',
      sorter: true,
    },
    {
      title: 'Propietario',
      dataIndex: 'owner',
      key: 'owner',
      // sorter: true, // TODO: Fix nested sorter
    },
    {
      title: 'Número de Póliza',
      dataIndex: 'insurancePolicyNumber',
      key: 'insurancePolicyNumber',
      // sorter: true, // TODO: Fix nested sorter
    },
    {
      title: 'Vencimiento de Póliza',
      dataIndex: 'insuranceExpirationDate',
      key: 'insuranceExpirationDate',
      // sorter: true, // TODO: Fix nested sorter
    },
    {
      title: 'Editar',
      key: 'operation_edit',
      fixed: 'right',
      width: 100,
      render: (props: TableData) => {
        return (
          <Link to={`${props.key}/editar`}>
            <CustomButton $theme="secondary" $isMini>
              <FaPen />
            </CustomButton>
          </Link>
        );
      },
    },
    {
      title: 'Borrar',
      key: 'operation_delete',
      fixed: 'right',
      width: 100,
      render: (item: TableData) => (
        <Popconfirm
          title="Precaución"
          description="¿Está seguro que quiere borrar el elemento? Este cambio es irreversible."
          onConfirm={() => {
            onDeleteSemitrailer(item.id.toString());
          }}
          okText="Eliminar"
          cancelText="Cancelar"
          okButtonProps={{ danger: true }}
        >
          <div>
            <CustomButton $theme="secondary" $isMini>
              <FaTrash />
            </CustomButton>
          </div>
        </Popconfirm>
      ),
    },
  ];

  const handleSearchByLicenseBrand = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onInputFilterChange(event.target.value);
    },
    [],
  );

  const handleFilterByCheckbox = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onInputCheckboxChange(event.target.checked);
    },
    [],
  );

  return (
    <StyledTableContainer>
      <StyledFiltersContainer>
        <InputCheckbox
          label="Póliza Vencida"
          customID="trucks-filter"
          onChange={handleFilterByCheckbox}
        />
        <InputText
          placeholder="Patente"
          onChange={handleSearchByLicenseBrand}
        />
      </StyledFiltersContainer>
      <Table
        columns={columns}
        dataSource={newData}
        pagination={{
          position: ['bottomCenter'],
          showSizeChanger: false,
          ...paginationData,
        }}
        onChange={onTableChange}
      />
    </StyledTableContainer>
  );
};

export default SemitrailersTable;
